import { Calendar } from "@/components/ui/calendar";
import { useLocale } from "@/hooks/useLocale";
import { MIN_PROJECT_DATE } from "@/constants";
import { DateTime } from "luxon";
import { DayPickerProps, PropsSingle } from "react-day-picker";

type CalendarSingleProps = Omit<
  PropsSingle,
  "mode" | "captionLayout" | "locale" | "required"
> &
  Pick<DayPickerProps, "endMonth" | "startMonth">;

export function CalendarSingle({
  endMonth,
  startMonth,
  ...props
}: CalendarSingleProps) {
  const locale = useLocale();

  return (
    <Calendar
      mode="single"
      captionLayout="dropdown"
      autoFocus
      locale={locale}
      startMonth={startMonth ?? MIN_PROJECT_DATE}
      endMonth={endMonth ?? DateTime.now().plus({ years: 5 }).toJSDate()}
      disabled={(date) => date < MIN_PROJECT_DATE}
      {...props}
    />
  );
}
